// extracted by mini-css-extract-plugin
module.exports = {"button":"_6c97079b1b--button--3Ho7Z"};